import type { IBatchGetListResponse } from '@/types/BatchTypes.d.ts'
import { ApiGet } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'

export async function BatchDetailGetList(filter : unknown): Promise<IBatchGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('BatchGetList')
  return ApiGet(url, filter)
}
